export const PropValueViewDefProps = {
  label: 'Prop label',
  value: 'Prop value'
};